<template>
    <div>
        <ChangeReseller
            ref="changeReseller"
            type="lead"
            @modelChanged="$emit('modelChanged', $event)"
        />
        <confirm-delete ref="confirmDelete" />
    </div>
</template>

<script>
import ChangeReseller from '../customer/ChangeReseller'

export default {
    components: {
        ChangeReseller,
    },

    methods: {
        async changeReseller(lead) {
            await this.$refs.changeReseller.open(lead)
        },

        async delete(lead) {
            let confirmed = await this.$refs.confirmDelete.confirm(
                lead.trade_name,
            )
            if (!confirmed) return

            await lead.delete()

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.lead.name'),
                }),
            )
        },
    },
}
</script>

<style></style>
